import RequestApi from "../../modules/requestApi";

/**
 * Связь хотспота и темы
 */
const actions = {
  // добавление связи хотспот - тема
  createHotspotTheme({ commit, getters }, params) {
    return new Promise((resolve, reject) => {
      RequestApi.createHotspotTheme(params)
        .then(data => {
          // добавляем связь к теме
          const theme = getters.getTheme(parseInt(data.theme_id));
          if (!theme.hotspot_themes) {
            theme.hotspot_themes = [];
          }
          commit("SET_THEME_ITEM", {
            id: data.theme_id,
            hotspot_themes: [...theme.hotspot_themes, data]
          });
          // добавляем связь к хотспоту
          commit("SET_HOTSPOT_ITEM", {
            id: data.hotspot_id,
            hotspot_themes: [data]
          });
          resolve(data);
        })
        .catch(reject);
    });
  },
  // удаление связи хотспот - тема
  deleteHotspotTheme({ commit, getters }, params) {
    let theme, hotspot, hotspot_themes;
    return new Promise((resolve, reject) => {
      RequestApi.deleteHotspotTheme(params)
        .then(data => {
          if (params.theme_id) {
            // удаляем связь к хотспоту у темы
            theme = getters.getTheme(parseInt(params.theme_id));
            if (params.hotspot_id) {
              // удаляем хотспот из указанной темы
              commit("SET_THEME_ITEM", {
                id: params.theme_id,
                hotspot_themes: theme.hotspot_themes.filter(
                  item => item.hotspot_id !== params.hotspot_id
                )
              });
            }
            if (!params.hotspot_id) {
              // удаляем все хотспоты из указанной темы
              commit("SET_THEME_ITEM", {
                id: params.theme_id,
                hotspot_themes: theme.hotspot_themes.filter(
                  item => item.theme_id !== params.theme_id
                )
              });
            }
          }
          if (params.hotspot_id) {
            hotspot = getters.getHotspot(parseInt(params.hotspot_id));

            // если удаляем все связи для хотспота не указав тему
            if (!params.theme_id) {
              // смотрим все темы хотспота
              hotspot_themes = hotspot.hotspot_themes.map(_ => _.theme_id);
              // удаляем связь к хотспоту у тем
              hotspot_themes.forEach(theme_id => {
                theme = getters.getTheme(parseInt(theme_id));
                commit("SET_THEME_ITEM", {
                  id: theme_id,
                  hotspot_themes: theme.hotspot_themes.filter(
                    item => item.hotspot_id !== params.hotspot_id
                  )
                });
              });
            }

            // удаляем связь к теме у хотспота
            commit("SET_HOTSPOT_ITEM", {
              id: params.hotspot_id,
              hotspot_themes: hotspot.hotspot_themes.filter(
                item => item.hotspot_id !== params.hotspot_id
              )
            });
          }
          resolve(data);
        })
        .catch(reject);
    });
  }
};

export default {
  actions
};
